import { patchUser, signOut } from '../slices/auth'
import type { User } from '../types'
import apiClient from './apiClient'

export const userApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<User, string>({
      query: (id) => ({ url: `/users/${id}`, method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'User', id }],
    }),
    updateUser: builder.mutation<User, Partial<User> & { _id: string }>({
      query: ({ _id, ...body }) => ({
        url: `/users/${_id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [{ type: 'User', id: arg._id }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          const next = (data as { user?: User })?.user ?? data
          if (next && typeof next === 'object' && '_id' in next) {
            dispatch(patchUser(next))
          } else {
            const { _id, ...rest } = arg
            void _id
            dispatch(patchUser(rest))
          }
        } catch {
          /* ignore */
        }
      },
    }),
    deleteUser: builder.mutation<{ success?: boolean }, { _id: string }>({
      query: ({ _id }) => ({ url: `/users/${_id}`, method: 'DELETE' }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(signOut())
          dispatch(apiClient.util.resetApiState())
        } catch {
          /* caller handles */
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const { useGetUserQuery, useUpdateUserMutation, useDeleteUserMutation } = userApi
